import React from "react";
import { Box, Grid, Paper, Skeleton, Typography } from "@mui/material";
import "./TrendsSkeleton.css";
const TrendsSkeleton: React.FC = () => {
  return (
    <Paper sx={{ marginTop: 2 }}>
      {/* Header with title and time unit selector */}
      <Grid container sx={{ padding: "16px 24px" }}>
        <Grid
          item
          xs={12}
          md={10}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Box>
            <Typography variant="body1" sx={{ fontWeight: "medium" }}>
              <Skeleton width={260} height={24} />
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={2}>
          <Skeleton variant="rectangular" height={40} />
        </Grid>
      </Grid>

      {/* Chart Skeleton */}
      <Box sx={{ px: 3, py: 2 }}>
        <div className="shimmer-box" />
      </Box>
    </Paper>
  );
};

export default TrendsSkeleton;
